export const SHOW = 'cnilBanner/SHOW';
export const HIDE = 'cnilBanner/HIDE';
export const SET_RGPD_COOKIE = 'cnilBanner/setRgpdCookieIsExisting';


export const FETCH_CNIL_REQUEST = 'cnilBanner/FETCH_CNIL_REQUEST';
export const FETCH_CNIL_SUCCESS = 'cnilBanner/FETCH_CNIL_SUCCESS';
export const FETCH_CNIL_FAILURE = 'cnilBanner/FETCH_CNIL_FAILURE';
